import { useSelector, useDispatch } from 'react-redux';
import { setDayMenuOtherUserDate } from '../../Redux/store';
import CloseButton from '../../components/CloseButton';
import DayMenuContent from './DayMenuContent';
import useProfileData from '../../hooks/useProfileData';
import useCalendarDataPredictedOtherUser from '../../hooks/useCalendarDataPredictedOtherUser';
import ModalWrapper from '../../components/ModalWrapper';

function DayMenuOtherUser() {
  const dispatch = useDispatch();
  // Get the date and userId from Redux state for the other user's day menu
  const dayMenuOtherUserDate = useSelector((s) => s.ui.dayMenuOtherUserDate);
  const date = dayMenuOtherUserDate?.date;
  const userId = dayMenuOtherUserDate?.userId;
  // Get the other user's profile data using the hook
  const { profile } = useProfileData(userId);
  // Fetch the other user's calendar data with predictions
  const { calendarData } = useCalendarDataPredictedOtherUser(userId);

  // Look up the specific day's data for the user whose profile we are looking at
  const dayData = date && userId ? calendarData?.[date] : null;
  // Get the other user's role to display the correct UI
  const role = profile?.role || 'ip';

  // Don't render if we don't have the required data
  if (!date || !userId) return null;

  // Close the menu by clearing the Redux state
  const close = () => dispatch(setDayMenuOtherUserDate(null));

  // Format the date for display
  const pretty = new Date(date + 'T00:00').toLocaleDateString(undefined, {
    weekday: 'long', month: 'long', day: 'numeric',
  });

  return (
    <ModalWrapper onClose={close} height="h-[95%]">
      {/* Fixed top header */}
      <div className="p-5 flex items-center justify-between flex-shrink-0">
        <h3 className="text-lg font-semibold">{pretty}</h3>
        <CloseButton onClose={close} />
      </div>

      {/* Scrollable middle content */}
      <DayMenuContent dayData={dayData} role={role} date={date} userId={userId} />

      {/* Fixed bottom button */}
      <div className="p-3 flex-shrink-0">
        <button onClick={close} className="w-full rounded-full bg-primary py-2.5 text-sm font-semibold text-primary-foreground">
          Done
        </button>
      </div>
    </ModalWrapper>
  );
}

export default DayMenuOtherUser;
